var STORAGE_KEY = "bn_user";
export var persistUser = function (user) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
};
export var getPersistedUser = function () {
    var stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
        var user = JSON.parse(stored);
        return user;
    }
    return null;
};
export var removePersistedUser = function () {
    window.localStorage.removeItem(STORAGE_KEY);
};
//# sourceMappingURL=authPersistance.js.map